<script>
export default {
    name: "SupplierJournalCategoryForm"
}
</script>
<template>
    <div class="flex flex-wrap">
        <div class="md:w-1/5 sm:w-full p-tiny">
            <label class="label-control" for="branch">G.L Account:</label>
            <v-select class="text-xs bg-white" :options="[ { label: 'Accounts Payable' } ]"></v-select>
        </div>
        <div class="md:w-1/5 sm:w-full p-tiny">
            <label class="label-control" for="category">Category:</label>
            <input type="text" class="input-control input-sm text-xs" id="category">
        </div>
        <div class="md:w-1/4 sm:w-full p-tiny">
            <label class="label-control" for="description">Description:</label>
            <input type="text" class="input-control input-sm text-xs" id="description">
        </div>
        <div class="md:w-1/12 sm:w-full p-tiny mt-4">
            <label for="active" class="label-control">Active
                <input type="checkbox" id="active">
            </label>
        </div>
        <div class="md:w-1/12 sm:w-full p-tiny mt-4">
            <label for="is_debit" class="label-control">Is Debit
                <input type="checkbox" id="is_debit">
            </label>
        </div>
        <div class="md:w-1/12 sm:w-full p-tiny mt-4">
            <button class="btn-info btn-sm text-xs rounded"><i class="fa fa-save"></i> Save</button>
        </div>
    </div>
</template>
